/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-cycle-check-list-item.reducer';

export const TreatmentCycleCheckListItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentCycleCheckListItemEntity = useAppSelector(state => state.treatmentCycleCheckListItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentCycleCheckListItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentCycleCheckListItem.detail.title">TreatmentCycleCheckListItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentCycleCheckListItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleCheckListItemEntity.id}</dd>
          <dt>
            <span id="result">
              <Translate contentKey="tinyMedicRestApp.treatmentCycleCheckListItem.result">Result</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleCheckListItemEntity.result ? 'true' : 'false'}</dd>
          <dt>
            <span id="resultComment">
              <Translate contentKey="tinyMedicRestApp.treatmentCycleCheckListItem.resultComment">Result Comment</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleCheckListItemEntity.resultComment}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentCycleCheckListItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleCheckListItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentCycleCheckListItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleCheckListItemEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentCycleCheckListItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleCheckListItemEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentCycleCheckListItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleCheckListItemEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentCycleCheckListItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentCycleCheckListItemEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentCycleCheckListItem.checklistItem">Checklist Item</Translate>
          </dt>
          <dd>{treatmentCycleCheckListItemEntity.checklistItem ? treatmentCycleCheckListItemEntity.checklistItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentCycleCheckListItem.cycle">Cycle</Translate>
          </dt>
          <dd>{treatmentCycleCheckListItemEntity.cycle ? treatmentCycleCheckListItemEntity.cycle.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-cycle-check-list-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-cycle-check-list-item/${treatmentCycleCheckListItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentCycleCheckListItemDetail;
